import { render, staticRenderFns } from "./needToDo.vue?vue&type=template&id=490c9f0e&scoped=true"
import script from "./needToDo.vue?vue&type=script&lang=js"
export * from "./needToDo.vue?vue&type=script&lang=js"
import style0 from "./needToDo.vue?vue&type=style&index=0&id=490c9f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c9f0e",
  null
  
)

export default component.exports